import React from 'react';
import Icon from '../../../components/AppIcon';
import { Link } from 'react-router-dom';

const HowItWorksSection = () => {
  const workflowSteps = [
    {
      id: 1,
      icon: "Cpu",
      title: "Deploy Agents",
      description: "Deploy intelligent agents to cloud, edge, or on-premises infrastructure. Sleeve manages lifecycle, health, and resource allocation."
    },
    {
      id: 2,
      icon: "GitBranch",
      title: "Orchestrate Workflows",
      description: "Define workflows that coordinate agents with legacy systems and human operators. Sleeve routes events and enforces policies."
    },
    {
      id: 3,
      icon: "Activity",
      title: "Monitor & Control",
      description: "Real-time visibility into all orchestrated workflows. Human oversight with approval gates for critical decisions."
    }
  ];

  return (
    <section className="py-24 px-4 md:px-6 lg:px-8 bg-card/30">
      <div className="max-w-7xl mx-auto">
        {/* Section Header */}
        <div className="text-center mb-12 md:mb-16 lg:mb-20">
          <h2 className="text-2xl font-bold text-foreground mb-3 md:mb-4 lg:mb-5">
            How Sleeve Works
          </h2>
          <p className="text-sm md:text-base lg:text-lg text-muted-foreground max-w-2xl mx-auto">
            A unified orchestration layer that coordinates agents, systems, and people across your infrastructure
          </p>
        </div>

        {/* Workflow Diagram */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 md:gap-8 lg:gap-10 relative">
          {/* Connection Lines - Desktop Only */}
          <div className="hidden md:block absolute top-1/2 left-0 right-0 h-0.5 bg-gradient-to-r from-transparent via-border to-transparent -translate-y-1/2 z-0" />

          {workflowSteps?.map((step, index) => (
            <div
              key={step?.id}
              className="relative group"
            >
              {/* Step Card */}
              <div className="relative z-10 bg-card border border-border rounded-lg p-6 md:p-7 lg:p-8 hover:border-primary/50 transition-all duration-300 h-full">
                {/* Step Number */}
                <div className="absolute -top-3 -left-3 w-8 h-8 md:w-9 md:h-9 lg:w-10 lg:h-10 rounded-full bg-background border-2 border-primary flex items-center justify-center">
                  <span className="text-xs md:text-sm font-bold text-primary">{step?.id}</span>
                </div>

                {/* Icon Container */}
                <div className="w-12 h-12 md:w-14 md:h-14 lg:w-16 lg:h-16 rounded-lg bg-primary/10 flex items-center justify-center mb-4 md:mb-5 lg:mb-6 group-hover:bg-primary/20 transition-colors duration-300">
                  <Icon name={step?.icon} size={24} color="var(--color-primary)" />
                </div>

                {/* Content */}
                <h3 className="text-base md:text-lg font-semibold text-foreground mb-2 md:mb-3">
                  {step?.title}
                </h3>
                <p className="text-xs md:text-sm lg:text-base text-muted-foreground leading-relaxed">
                  {step?.description}
                </p>
              </div>

              {/* Arrow Connector - Mobile */}
              {index < workflowSteps?.length - 1 && (
                <div className="md:hidden flex justify-center my-4">
                  <Icon name="ArrowDown" size={20} color="var(--color-primary)" />
                </div>
              )}
            </div>
          ))}
        </div>

        {/* CTA Below Section */}
        <div className="text-center mt-12 md:mt-16 lg:mt-20">
          <Link 
            to="/product"
            className="inline-flex items-center gap-2 px-6 py-3 rounded-lg bg-muted border border-border text-sm md:text-base text-foreground font-medium hover:border-primary/50 transition-all duration-300"
          >
            Explore Technical Architecture
            <Icon name="ArrowRight" size={16} color="currentColor" />
          </Link>
        </div>
      </div>
    </section>
  );
};

export default HowItWorksSection;